import { render } from "./NewMaterialModal.vue?vue&type=template&id=a55ed044&scoped=true"
import script from "./NewMaterialModal.vue?vue&type=script&lang=js"
export * from "./NewMaterialModal.vue?vue&type=script&lang=js"

import "./NewMaterialModal.vue?vue&type=style&index=0&id=a55ed044&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55ed044"]])

export default __exports__